import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07929f76"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "change-password-form" }
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = { for: "currentPassword" }
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = { for: "password" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = { for: "confirmPassword" }
const _hoisted_8 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_field = _resolveComponent("v-field")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_form, { onSubmit: _ctx.onSubmit }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('CustomerDetails.CurrentPassword')), 1),
          _createVNode(_component_v_field, {
            name: "currentPassword",
            type: "password",
            id: "currentPassword",
            modelValue: _ctx.currentPassword,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentPassword) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('CustomerDetails.NewPassword')), 1),
          _createVNode(_component_v_field, {
            name: "password",
            type: "password",
            id: "password",
            modelValue: _ctx.password,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('CustomerDetails.NewPasswordConfirm')), 1),
          _createVNode(_component_v_field, {
            name: "confirmPassword",
            type: "password",
            id: "confirmPassword",
            modelValue: _ctx.confirmPassword,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.confirmPassword) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createVNode(_component_BaseButton, {
          class: "button--base button--primary",
          type: "submit"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('CustomerDetails.ChangePassword')), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["onSubmit"]),
    (_ctx.errorMessage)
      ? (_openBlock(), _createElementBlock("p", {
          key: 0,
          class: "mt-2",
          innerHTML: _ctx.errorMessage
        }, null, 8, _hoisted_8))
      : _createCommentVNode("", true)
  ]))
}